/* Utils */
import { REPORT_GA } from '../../../../utils/constants';
import loginDeviceToolbox from './loginDeviceToolbox';
import { gaService } from '../../../../services/gaService';

export default function loginDevice(loginDeviceParams) {
  let intervalId;
  function listenLoginDeviceService() {
    intervalId = setInterval(() => callRegisterDeviceService(), 10_000);
  }

  function stopListenLoginDeviceService() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = undefined;
    }
  }

  async function callRegisterDeviceService() {
    try {
      await loginDeviceToolbox(loginDeviceParams);
      stopListenLoginDeviceService();
      gaService.sendEvent({
        action: REPORT_GA.GA_EVENT_ACTION_ACTIVATION_SUCCESS,
        label: REPORT_GA.GA_EVENT_LABEL_NA,
        category: REPORT_GA.GA_EVENT_CATEGORY_DEVICE_ACTIVATION,
      });
      return true;
    } catch {
      return false;
    }
  }

  listenLoginDeviceService();

  return stopListenLoginDeviceService;
}
